<template>
  <div>
    <v-dialog v-model="sparkLinesDialog" max-width="1024px">
      <v-card>
        <v-card-title class="mx-3">
          <span
            class="red--text d-inline-block text-truncate"
            style="max-width: 360px"
          >
            {{ lineChartMaterialName }}
          </span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="sparkLinesDialog = false"
              >
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-card-text class="pa-8 text-center subtitle-1">
          <div id="chartLineBox" style="height: 45vh"></div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <DialogAlert
      v-model="noLineDataAlert"
      :title="lineChartMaterialName"
      :message="$t('Quotations.DetailFields.nolineChartDataMassage')"
    />
  </div>
</template>
<script>
import i18n from "@/i18n";
import DialogAlert from "@/components/plugins/DialogAlert";
import Quotations from "@/api/quotations";
// 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口。
import * as echarts from "echarts";

export default {
  name: "DialogEconomyHistoryEcharts",

  components: {
    DialogAlert,
  },

  props: {
    value: Boolean,
    currentDetail: Object,
    supplierId: Number,
    lineChartMaterialName: String,
  },

  data: () => ({
    dialog: false,
    economy_history: [],
    sparkLinesDialog: false,
    noLineDataAlert: false,
    xAxisData: [],
    lineChartData: [],
    monitorTime: "",
  }),
  methods: {
    drawLineChart() {
      this.chartLine = echarts.init(document.getElementById("chartLineBox"));

      // 指定图表的配置项和数据
      var option = {
        tooltip: {
          //设置tip提示
          trigger: "axis",
        },

        // legend: {
        //设置区分（哪条线属于什么）
        // data: [],
        // },
        color: ["#26A69A"], //设置区分（每条线是什么颜色，和 legend 一一对应）
        toolbox: {
          show: true,
          feature: {
            dataZoom: {
              yAxisIndex: 'none'
            },
            // restore: {},
            // saveAsImage: {}
          }
        },
        xAxis: {
          //设置x轴
          type: "category",
          boundaryGap: false, //坐标轴两边不留白
          data: this.xAxisData,
          // data: [0,1,2,3],
          name: i18n.t("Quotations.DetailFields.xAxisName"), //X轴 name
          nameTextStyle: {
            //坐标轴名称的文字样式
            color: "#26A69A",
            fontSize: 16,
            padding: [0, 0, 0, 15],
          },
          axisLine: {
            //坐标轴轴线相关设置。
            lineStyle: {
              color: "#26A69A",
            },
          },
        },
        yAxis: {
          name: i18n.t("Quotations.DetailFields.yAxisName"),
          nameTextStyle: {
            color: "#26A69A",
            fontSize: 16,
            padding: [0, 0, 10, 0],
          },
          axisLine: {
            lineStyle: {
              color: "#26A69A",
            },
          },
          type: "value",
        },
        series: [
          {
            name: this.lineChartMaterialName,
            data: this.lineChartData,
            // data: [10,2,5,20],
            type: "line", // 类型为折线图
            markPoint: {
              data: [
                { type: 'max', name: 'Max' },
                { type: 'min', name: 'Min' }
              ]
            },
            markLine: {
              data: [{ type: 'average', name: 'Avg' }]
            },
            lineStyle: {
              color: "#26A69A",
            },
          },
        ],
      };

      // 使用刚指定的配置项和数据显示图表。
      this.chartLine.setOption(option);
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.dialog = this.value;
        if (this.dialog) {
          Quotations.getEconomyHistory({supplier_id: this.supplierId, material_id: this.currentDetail.material_id}).then(
            function (response) {
              if (response.data.status.isOK()) {
                if (response.data.economy_history != []) {
                  this.economy_history = response.data.economy_history;
                }else {
                  this.noLineDataAlert = true
                }
              }
          }.bind(this))

        }
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
      },
    },
    noLineDataAlert: {
      handler() {
        if (!this.noLineDataAlert) {
          this.$emit("close", this.dialog);
        }
      }
    },
    economy_history: {
      deep: true,
      handler() {
        if (this.economy_history) {
          //整理折线图坐标点的数据
          for (let date in this.economy_history) {
            if (this.economy_history[date] && this.economy_history[date][this.currentDetail.material_id]) {
              if (this.xAxisData.indexOf(this.economy_history[date][this.currentDetail.material_id].date) == -1) {
                this.xAxisData.push(this.economy_history[date][this.currentDetail.material_id].date);
                this.lineChartData.push(this.economy_history[date][this.currentDetail.material_id].old_supply_price);
              }
            }
          }

          if (this.xAxisData.length && this.lineChartData.length) {
            this.sparkLinesDialog = true;
          } else {
            this.noLineDataAlert = true;
          }
        }
      },
    },
    sparkLinesDialog: {
      handler() {
        if (this.sparkLinesDialog) {
          //渲染折线图
          clearInterval(this.monitorTime);
          this.monitorTime = setTimeout(
                  function () {
                    this.drawLineChart();
                  }.bind(this),
                  1
          );
        } else {
          this.xAxisData = [];
          this.lineChartData = [];
          echarts.dispose(document.getElementById("chartLineBox"))
          this.$emit("close", this.dialog);

        }
      },
    },
  },
  beforeDestroy() {
    clearInterval(this.monitorTime);
  },
};
</script>